/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCRightIcon24Regular = forwardRef('ArrowCRightIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7.881 3.383a.875.875 0 0 1 1.238 0l6.406 6.407a3.125 3.125 0 0 1 0 4.42L9.12 20.616A.875.875 0 0 1 7.88 19.38l6.407-6.407a1.375 1.375 0 0 0 0-1.944L7.881 4.62a.875.875 0 0 1 0-1.238Z" })));
});
